import { ChangeDetectionStrategy, Component, computed, inject, input, InputSignal } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import { Deposit } from '@connect-services/client/sdk/api';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-deposit-status',
    templateUrl: './deposit-status.component.html',
})
export class DepositStatusComponent {
    public readonly deposit: InputSignal<Deposit | undefined> = input.required<Deposit | undefined>();
    public readonly hasStandard: InputSignal<boolean> = input.required();

    protected readonly dataTooltip = computed<string>(() => this.getDepositTooltip(this.deposit(), this.isValid()));
    protected readonly Deposit = Deposit;
    protected readonly isValid = computed<boolean>(() => !!this.deposit()?.depositValidation?.isValid);
    protected readonly status = computed<Deposit.StatusEnum | undefined>(() => this.deposit()?.status);

    private readonly translocoService = inject(TranslocoService);

    private getDepositTooltip(deposit: Deposit | undefined, isDepositValid: boolean): string {
        const tooltips: string[] = [];
        if (deposit?.hadDataAtImport === false) {
            tooltips.push(`︎︎︎✖︎ ${this.translocoService.translate('depositNoData')}`);
        } else {
            tooltips.push(`︎︎︎✔︎ ${this.translocoService.translate('depositHasData')}`);
        }

        if (!isDepositValid) {
            tooltips.push(
                `✖︎ ${this.translocoService.translate(this.hasStandard() ? 'errorStandardDeposit' : 'errorValidityDeposit')}`,
            );
        }

        return tooltips.join('\n');
    }
}
